import "./models.scss";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useSelector } from "react-redux";

const Models = () => {
    const [modelsList, setModelsList] = useState([]);

    const permissions = useSelector((state) => state.status.permissions);

    const { data: models, refetch: refetchModels } = useGetPageQuery("models?per_page=100");
    const [deleteModels, { isLoading, isError }] = useSendFormMutation();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setModelsList([...modelsList, e.target.value]);
        } else if (!e.target.checked) {
            setModelsList([...modelsList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteModelsHandler = async () => {
        for (const model of modelsList) {
            await deleteModels({ body: {}, url: "models/" + model, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchModels();
    };

    const checkAllHandler = () => {
        setModelsList(models.data.map((model) => model.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetchModels();
        };
        refetch();
    }, [models]);

    const convertDate = (date) => {
        const newDate = new Date(date);
        const dateString = newDate.toLocaleDateString({
            weekday: "short",
            year: "numeric",
            month: "2-digit",
            day: "numeric",
        });

        return dateString.replace(/\//g, ".");
    };

    return (
        <>
            {models && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>{models.data.length} Моделей</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/model"} className="add btn btn-primary">
                                        Додати модель
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <a className="check_all" onClick={checkAllHandler}>
                            Виділити все
                        </a>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th data-field="check"></th>
                                    <th data-field="id" className="no-mobile">
                                        ID
                                    </th>
                                    <th data-field="user_name">Назва</th>
                                    <th data-field="user_date" className="no-mobile">
                                        Створено
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {models.data.map((model) => {
                                    return (
                                        <tr key={model.id}>
                                            <td className="check_area fit text-right">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        value={model.id}
                                                        onChange={(e) => listCheckHandler(e)}
                                                        checked={modelsList.includes(model.id.toString())}
                                                    />
                                                    <label className="custom-control-label">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td className="fit no-mobile">#{model.id}</td>
                                            <td>
                                                <Link to={"/model/" + model.id}>{model.title}</Link>
                                            </td>
                                            <td className="fit no-mobile"> {convertDate(model.created_at)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {permissions.includes("model_edit") || permissions.includes("all") ? (
                            <div className="d-flex">
                                <select name="action" className="form-select" style={{ width: "auto" }}>
                                    <option value="delete">Видалити</option>
                                </select>
                                <button className="btn btn-info mx-3" onClick={deleteModelsHandler}>
                                    {isLoading ? "Завантаження" : "Виконати"}
                                </button>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};

export default Models;
